import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import { useSummaryModel } from "./summaryModel";

export function PageHeader() {
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData,
    } = useSummaryModel();

    const onSearch = (val = {}) => {
        loadData({ pageNum: 1 }, { ...searchParam, ...val })
    }

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "合约单号",
            fieldName: "code",
            size: "small",
            disabled: false
        },
        {
            type: SearchTypeEnum.Input,
            xxl: 4,
            span: 4,
            placeholder: "客户名称",
            fieldName: "partnerName",
            size: "small",
            disabled: false
        },
    ]

    return (
        <YhPageHeader
            title="合约管理"
            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            justify={'end'}
            triggerSearch
            onChange={updateSearchParam}
            handleSearch={onSearch}
            handleReset={resetSearchParam}
        />
    );
}